<template>
  <v-container fluid pa-0 dark flat class="background-duo" :class="{shakeX: shake, animated: shake}"> <!--:class="{shakeX: shake, animated: shake}" -->
    <div class="d-flex align-center flex-container-selection">
      
      <h2 class="flex-inner white--text">Cotiza acá</h2>
      <div class="w-100 flex-inner" :class="$vuetify.breakpoint.smAndDown ? 'my-1':'my-4'">
        <!-- <v-img class="link mx-auto" :src='require("../../assets/static/img/home-button.png")' max-width="300px" v-on:click="goTo('mudanza', 'soloElementosHogar')"></v-img> -->
        <v-img class="link mx-auto" :src='require("../../assets/static/img/home-button.png")' max-width="300px" @click="goToWS(1)"></v-img>
        <h3 class="font-weight-regular text-xs-center" style="color:white">Solo elementos de hogar</h3>
      </div>
      <div v-if="mobile" class="w-100 flex-inner" style="padding-left: 20px;">
        <br>
          <hr class="divider-service-links" noshade width="90%" height="1px" background-opacity="10" align="center">
        <br>
      </div>
      <div class="w-100 flex-inner" :class="$vuetify.breakpoint.smAndDown ? 'my-1':'my-4'">
        <!-- <v-img class="link mx-auto" :src='require("../../assets/static/img/otros-button.png")' max-width="300px" v-on:click="goTo('contacto', 'otroTipoDeElementos')"></v-img> -->
        <v-img class="link mx-auto" :src='require("../../assets/static/img/otros-button.png")' max-width="300px" v-on:click="goToWS(2)"></v-img>
        <h3 class="font-weight-regular text-xs-center" style="color:white">Otro tipo de elementos</h3>
      </div>
      <!-- seba empezo aqui
      <v-container :class="{shakeX: shake, animated: shake}" >
        <div v-if="mobile" class="w-100 flex-inner" style="padding-left: 20px;" >
          <br>
            <hr class="divider-service-links" noshade width="90%" height="1px" background-opacity="10" align="center">
          <br>
        </div>
        <div class="w-100 flex-inner" :class="$vuetify.breakpoint.smAndDown ? 'my-1':'my-4'">
          <v-img class="link mx-auto" :src='require("../../assets/static/img/home-button.png")' max-width="300px" v-on:click="goTo('mudanza', 'soloElementosHogar')"></v-img>
          <h3 class="font-weight-regular text-xs-center" style="color:white">Cotizacion Rapida *Nuevo*</h3>
        </div>
      </v-container>  
      seba terminó aqui-->
    </div>
  </v-container>
</template>

<script>
  import { EventBus } from '../../events.js'
  import resize from 'vue-resize-directive'
  export default {
    name: 'SelectionOverSlider',
    directives: {
      resize
    },
    data () {
      return {
        shake: false,
        mobile: false,
        windowWidth: 0
      }
    },
    mounted(){
      this.$nextTick(function() {
	      window.addEventListener('resize', this.getWindowWidth)
	      this.getWindowWidth()
	    })
      setTimeout(() => {
        this.shake = false
      }, 2000);
    },
    methods: {
      goToWS(tipo){
			  const texto = tipo == 1 ? '¡Hola! Quiero cotizar una mudanza de hogar.' : '¡Hola! Quiero cotizar un flete para Empresa.'
        const url = 'https://wa.me/56996711666?text=' + texto
        const windowOpen = window.open(url)
        windowOpen
      },
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      	this.mobile = false
        if( this.windowWidth < 762 ){
        	this.mobile = true
        }
      },
      goTo(route, tipo){
        this.eventTracker(tipo)
        this.$router.push({name: route})
      },
      onResize(){
        EventBus.$emit('selectionHeight', this.$refs.fullSelectionContainer.clientHeight)
      },
      eventTracker(tipo) {
        console.log('entra aqui')
        gtag('event', tipo, {
          'event_category' : tipo,
          'event_label' : tipo
        })
      }
    }
  }
</script>

<style scoped>
  .w-100{
    width: 100%;
  }
  .flex-container-selection{
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .flex-container-selection .flex-inner{
    flex: 0!important;
  }
  .background-duo{
    height: 100%;
    max-width: 420px;
    background-color: rgba(31, 151, 185, 0.9)
  }
</style>